<template>
  <div id="wrapper"   >
      <audio id="audio" src="./static/asstes/bg-audio.mp3" preload  loop="loop" ></audio>
      <Navigation v-if="isNav" />
      <ParkDetail  v-if="isPark" :title="title" />
      <TowerDetail v-if="isTower" :towerTitle="tower" :towerData="towerData" />
      <AreasDetail v-if="isAreas" :selectArea="selectArea" />
      <Login v-if="isLogin" />
      <div  id="pano"></div>
      <div v-if="isShowUser" class="btn" @click="handleLogin(true)" >
          <van-icon name="contact" class="user" />
      </div>
  </div>
</template>
<script>
    import Navigation from '../commonComponents/Navigation.vue'
    import ParkDetail from '../commonComponents/ParkDetail.vue'
    import TowerDetail from '../commonComponents/TowerDetail.vue'
    import AreasDetail from '../commonComponents/AreasDetail.vue'
    import {Toast} from 'vant'
    import Login from './Login.vue'
    import http from '../config/axios.js'
    export default {
        name:'vtour',
        data(){
            return {
                isShowUser:false,
                isShowVtour:'true',
                loginText:'登入',
                isLogin:false,
                isPark:false,
                isTower:false,
                tower:'A11111',
                isNav:false,
                isAreas:false,
                selectArea:'bg-image-hall',
                title:'张江中区',
                parkData: [],
                towerData:{
                    towerDetail:[],
                    lookRecords:[],
                    signRecords:[]
                },
                sign:true
            }
        },
        created(){
            window.vtour={
                isShowPark: this.isShowPark,
                isShowTower:this.isShowTower,
                isShowNav:this.isShowNav,
                isShowAreas:this.isShowAreas,
                getTowerState:this.getTowerState,
                requestFullScreen:this.requestFullScreen,
                exitFull:this.exitFull,
                audioIsPlay:this.audioIsPlay
            }
        },
        mounted(){
            embedpano({swf:"./static/vtour/tour.swf", xml:"./static/vtour/tour.xml", target:"pano", html5:"auto", mobilescale:1.0, passQueryParameters:true,onready:this.krpano_onready_callback});
            document.onclick=this.showXY;
            
            // window.setTimeout(function(){
            //     const audio = document.getElementById('audio')
            //     // alert('1111')
            //     audio.play()
            // },10000)
            // this.iosPlay()
        },
        watch:{

        },
        methods:{
            iosPlay(){
                const self = this
                document.addEventListener('touchstart', function () {
                    function audioAutoPlay(a) {
                        if(a){
                            const audio = document.getElementById('audio');
                            audio.play();
                            // this.krpano.call("set(layer[%1].crop, '900|100|100|100');")
                            self.sign = false;
                        }
                            
                    }
                    audioAutoPlay(self.sign);
                });
            },
            audioIsPlay(isPlay){
                const audio = document.getElementById('audio')
                console.log(audio.autoplay,'audio')
                if(isPlay){
                    audio.play()
                } else{
                    window.setTimeout(()=>{
                        audio.pause()
                    },100)
                    
                }

            },
            handleLogin(sign){
                this.isLogin = sign;
                // Toast('登入过期！请重新登入')
            },
            requestFullScreen() {
                const element = document.documentElement
                // 判断各种浏览器，找到正确的方法
                var requestMethod = element.requestFullScreen || //W3C
                element.webkitRequestFullScreen || //Chrome等
                element.mozRequestFullScreen || //FireFox
                element.msRequestFullScreen; //IE11
                if (requestMethod) {
                requestMethod.call(element);
                }
                else if (typeof window.ActiveXObject !== "undefined") {//for Internet Explorer
                var wscript = new ActiveXObject("WScript.Shell");
                if (wscript !== null) {
                wscript.SendKeys("{F11}");
                }
                }
            },
            exitFull() {
                console.log('exitFull')
                // 判断各种浏览器，找到正确的方法
                var exitMethod = document.exitFullscreen || //W3C
                document.mozCancelFullScreen || //Chrome等
                document.webkitExitFullscreen || //FireFox
                document.webkitExitFullscreen; //IE11
                if (exitMethod) {
                exitMethod.call(document);
                }else if(typeof window.ActiveXObject !== "undefined") {//for Internet Explorer
                var wscript = new ActiveXObject("WScript.Shell");
                if (wscript !== null) {
                wscript.SendKeys("{F11}");
                }
                }
            },
            getTowerData(code){
                http.post('pano/selectPanoBuildingInfo.do',{code:code})
                .then(data=>{
                    // if(data.data.tokenState == 0 ){
                        
                    //     if(JSON.parse(localStorage.getItem('token'))){
                    //         this.handleLogin(true)
                    //         Toast('登入过期！请重新登入')
                    //         localStorage.removeItem('token');
                    //     }
                    // }
                    data = data.data
                    if(data.signRecords){
                        data.signRecords.forEach(item1=>{
                            if(item1.leaseType == 0){
                                item1.towerTitle = this.tower
                            } else{
                                item1.towerTitle = this.lookFloorInfo
                            }
                        })
                    }
                    
                    data.towerDetail=[]
                    const temp =data.desp.split('#pano1#')
                    
                    temp.forEach(item=>{
                        let tempObj={}
                        const temp1 = item.split('#pano#')
                        tempObj.name = temp1[0]
                        tempObj.detail = temp1[1]
                        data.towerDetail.push(tempObj)
                    })
                    this.towerData = data

                    console.log(data,'data')
                }).catch(err=>{
                    console.log('err',err)
                })
            },
            getTowerState(code){
                http.post('dir/selectParkList.do',{parentCode:code})
                .then(data=>{
                    // if(data.data.tokenState == 0 ){
                    //     if(JSON.parse(localStorage.getItem('token'))){
                    //          this.handleLogin(true)
                    //         Toast('登入过期！请重新登入')
                    //         localStorage.removeItem('token');
                    //     }
                    // }
                    this.parkData = data.data
                    let sign = 't'
                    if(code == '100'){
                        sign = 't'
                    } else if(code == '101') {
                        sign = 'y'
                    } else{
                        sign = 'k'
                    }
                    if(localStorage.getItem('token') && (data.data.tokenState != 0) ){
                        data.data.parks.forEach(item=>{
                            if(item.state == 0){
                                this.krpano.call("set(hotspot[titile-"+sign+"-"+item.name+"].url,'./static/vtour/bgpic/gray.png');set(hotspot[titile-"+sign+"-"+item.name+"].tooltip,'待定')")
                            } else if(item.state == 1) {
                                this.krpano.call("set(hotspot[titile-"+sign+"-"+item.name+"].url,'./static/vtour/bgpic/gray.png');set(hotspot[titile-"+sign+"-"+item.name+"].tooltip,'有意向')")
                            } else if(item.state == 2){
                                this.krpano.call("set(hotspot[titile-"+sign+"-"+item.name+"].url,'./static/vtour/bgpic/blue.png');set(hotspot[titile-"+sign+"-"+item.name+"].tooltip,'预约')")
                            } else if(item.state == 3){
                                this.krpano.call("set(hotspot[titile-"+sign+"-"+item.name+"].url,'./static/vtour/bgpic/red.png');set(hotspot[titile-"+sign+"-"+item.name+"].tooltip,'签约')")
                            }  else if(item.state == 4){
                                this.krpano.call("set(hotspot[titile-"+sign+"-"+item.name+"].url,'./static/vtour/bgpic/green.png');set(hotspot[titile-"+sign+"-"+item.name+"].tooltip,'空置')")
                            }  else {
                                this.krpano.call("set(hotspot[titile-"+sign+"-"+item.name+"].url,'./static/vtour/bgpic/red.png');set(hotspot[titile-"+sign+"-"+item.name+"].tooltip,'空置')")
                            }
                        })
                    }else{
                        data.data.parks.forEach(item=>{
                            this.krpano.call("set(hotspot[titile-"+sign+"-"+item.name+"].url,'./static/vtour/bgpic/gray.png')")
                        })
                    }
                   
                    
                }).catch(err=>{
                    console.log('err',err)
                })
            },
            editTittle(title){
                switch(title){
                    case 'scene_hp-1-t':
                        this.title = '国际人才港';break;
                    case 'scene_hp-3-y':
                        this.title = '研创园';break;
                    case 'scene_hp3g-k':
                        this.title = '人工智能岛';break;
                    case 'scene_hp-n':
                        this.title = '张江中区';break;
                    default: break;
                }
            },
            isShowAreas(isShow, select){
                if(isShow){
                    this.isAreas = true
                    this.selectArea = select
                } else{
                    this.isAreas = false
                }
                
            },
            // 小行星运行完毕
            isShowNav(){
                this.isNav = true;
                this.isShowUser = true;
            },
            showXY(){
                var mx = this.krpano.get("mouse.x");
                var my = this.krpano.get("mouse.y");
                var pnt = this.krpano.screentosphere(mx,my);
                var h = pnt.x;
                var v = pnt.y;
                console.log('x="' + mx + '" y="' + my + '" ath="' + h.toFixed(2) + '" atv="' + v.toFixed(2) + '"')
            },
            krpano(){

            },
            krpano_onready_callback(obj){
                console.log('krpano')
                window.krpano = obj
                this.krpano= obj
            },
            isShowPark(isShow){
                
                if(isShow){
                    this.isPark = true
                } else{
                    this.isPark = false
                    // krpano.call("set(layer[lefttop_icon04].crop, '400|0|100|100')")
                }
            },
            isShowTower(isShow,tower){
                if(tower && this.tower !== tower ){
                    // 这里楼层的信息
                    this.tower = tower
                    let code = ''
                    this.parkData.parks.forEach(item=>{
                        if(item.name == tower){
                            code = item.code
                        }
                    })
                    if(code){
                        this.getTowerData(code)
                    }
                }
                if(isShow){
                    this.isTower = true
                } else{
                    this.isTower = false
                }
            }
        },
        components:{ Navigation, ParkDetail, TowerDetail, AreasDetail, Login}
    }
</script>
<style lang="scss" scoped>
    .btn{
        position: fixed;
        z-index:101;
        color:#fff;
        top:50%;
        margin-top:-210px;
        cursor: pointer;
        right:10px;
        background:rgba(0,0,0,0.5);
        border-radius: 50%;
        width:40px;
        height:40px;
        text-align:center;
        .user{
            line-height:40px;
            font-size:20px;
        }
    }
    #wrapper{
        width: 100%;
        height: 100%;
        position: absolute;
    }
    #pano{
        width: 100%;
        height: 100%;
    }
    .img_btn{
        width:60px;
        height: 60px;
        position: absolute;
        top:10px;
        right:6px;
        z-index:4010;
    }
    .showUp{
        animation:showup 0.4s ease-in;
    }
    .hideDown{
        animation:hidedown 0.4s ease-out;
    }

    @keyframes showup {
        from {
            transform:translateY(110%);
            opacity: 0;
        }
        to {
            transform: translateY(0);
            opacity: 1;
        }
        
    }
    @keyframes hidedown {
        from {
            transform: translateY(0);
        }
        to {
            transform: translateY(110%);
        }
        
    }
</style>




// WEBPACK FOOTER //
// src/components/Vtour.vue